$(function() {

    // Search Form
    $('#faq #searchform .submit').off('click').on('click', (e) => {

        e.preventDefault();

        $('#faq #search-results .error').removeClass('d-block');
        $('#faq #search-results .error').addClass('d-none');
        $('#faq #search-results .nocontent').removeClass('d-block');
        $('#faq #search-results .nocontent').addClass('d-none');

        if ($('#faq #searchform #search').val().length < 4) {
            $('#faq #search-results .error').removeClass('d-none');
            $('#faq #search-results .error').addClass('d-block');
            return false;
        }

        $('#faq #search-results .search-results-list').empty();

        let position = 0;
        $('#faq #faq-questions .accordion .accordion-item-container').each(function() {
            position = $(this).text().toLowerCase().search($('#faq #searchform #search').val().toLowerCase());
            if (position > -1) {
                $(this).clone().appendTo('#faq #search-results .search-results-list');
            }
        });

        if(!/[\S]/.test($('#faq #search-results .search-results-list').html())) {
            $('#faq #search-results .nocontent').removeClass('d-none');
            $('#faq #search-results .nocontent').addClass('d-block');
        }


    });

    // Category selection in desktop mode
    $('#faq #faq-categories .list-group .list-group-item .btn').off('click').on('click', (e) => {

        let el = '#faq #faq-categories .list-group .list-group-item .btn#'+e.target.id;
        let category = e.target.id;

        if (e.target.classList.contains("active")) {
            e.stopPropagation();
            return false;
        }

        $('#faq #faq-categories .list-group .list-group-item .btn').removeClass('active');
        $('#faq #faq-categories .list-group .list-group-item .btn').attr('data-bs-toggle','collapse');
        $(el).addClass('active');
        $(el).removeAttr('data-bs-toggle');

        // Dealing with Category Selection in mobile mode
        let mobile_el = '#faq #faq-categories .dropdown .dropdown-item#'+category;
        $('#faq #faq-categories .dropdown .dropdown-item').removeClass('active');
        $('#faq #faq-categories .dropdown .dropdown-item').removeAttr('aria-current');
        $(mobile_el).addClass('active');
        $(mobile_el).attr('aria-current',true);
        $('#faq #faq-categories .dropdown .dropdown-toggle').text($(mobile_el).text());

    });

    // Category selection in mobile mode
    $('#faq #faq-categories .dropdown .dropdown-item').off('click').on('click', (e) => {

        let el = '#faq #faq-categories .dropdown .dropdown-item#'+e.target.id;
        let category = e.target.id;

        if (e.target.classList.contains("active")) {
            e.stopPropagation();
            return false;
        }

        $('#faq #faq-categories .dropdown .dropdown-item').removeClass('active');
        $('#faq #faq-categories .dropdown .dropdown-item').removeAttr('aria-current');
        $(el).addClass('active');
        $(el).attr('aria-current',true);
        $('#faq #faq-categories .dropdown .dropdown-toggle').text($(el).text());

        // Dealing with Category Selection in desktop mode
        let desktop_el = '#faq #faq-categories .list-group .list-group-item .btn#'+category;
        $('#faq #faq-categories .list-group .list-group-item .btn').removeClass('active');
        $('#faq #faq-categories .list-group .list-group-item .btn').attr('data-bs-toggle','collapse');
        $(desktop_el).addClass('active');
        $(desktop_el).removeAttr('data-bs-toggle');

    });



    // By default selecting the first
    // Category Desktop
    $('#faq #faq-categories .list-group .list-group-item.category-0').addClass('active');
    $('#faq #faq-categories .list-group .list-group-item.category-0 .btn').removeClass('collapsed');
    $('#faq #faq-categories .list-group .list-group-item.category-0 .btn').addClass('active');
    $('#faq #faq-categories .list-group .list-group-item.category-0 .btn').removeAttr('data-bs-toggle');
    $('#faq #faq-categories .list-group .list-group-item.category-0 .btn').attr('aria-expanded', true);
    // Category Mobile
    $('#faq #faq-categories .dropdown .dropdown-item.category-0').addClass('active');
    $('#faq #faq-categories .dropdown .dropdown-item.category-0').attr('aria-current',true);
    $('#faq #faq-categories .dropdown .dropdown-toggle').text($('#faq #faq-categories .dropdown .dropdown-item.category-0').text());

    $('#faq #faq-questions .faq:first').addClass('show');


});

